const facilityType = [
    { titleSelect: 'CREDIT / FINANCING', valSelect: 'F01' },
    { titleSelect: 'CREDIT / FINANCING JOIN ACCOUNT', valSelect: 'F02' },
    { titleSelect: 'BOND / SECURITIES', valSelect: 'F03' },
    { titleSelect: 'IRREVOCABLE LC', valSelect: 'F04' },
    { titleSelect: 'BANK GUARANTEE', valSelect: 'F05' },
    { titleSelect: 'OTHER FACILITIES', valSelect: 'F06' },
]

export default facilityType;